import { Form, Formik } from "formik";
import moment from "moment";
import * as Yup from "yup";
import ExportSiniestralidadButton from "../../commons/export/ExportarSiniestralidadButton";
import FormikDatePicker from "../../commons/formik/FormikDatePicker";
import { StyledEstablecimientos } from "../../styled/Prevencion";

const validationSchema = Yup.object({
    fechaDesde: Yup.mixed()
        .nullable()
        .test(
            "fechaDesde-valid-date",
            "Debe ser una fecha válida",
            function (fechaDesde) {
                if (!fechaDesde) return true;
                return fechaDesde instanceof Date && !isNaN(fechaDesde);
            }
        )
        .test(
            "fechaDesde-before-today",
            "La fecha desde debe ser anterior o igual a hoy",
            function (fechaDesde) {
                if (!fechaDesde || !(fechaDesde instanceof Date) || isNaN(fechaDesde)) return true;
                const today = new Date();
                today.setHours(23, 59, 59, 999);
                return fechaDesde <= today;
            }
        )
        .test(
            "fechaDesde-before-fechaHasta",
            "La fecha desde debe ser anterior o igual a la fecha hasta",
            function (fechaDesde) {
                const { fechaHasta } = this.parent;
                if (!fechaDesde || !fechaHasta || !(fechaDesde instanceof Date) || !(fechaHasta instanceof Date) || isNaN(fechaDesde) || isNaN(fechaHasta)) return true;
                return fechaDesde <= fechaHasta;
            }
        ),
    fechaHasta: Yup.mixed()
        .nullable()
        .test(
            "fechaHasta-valid-date",
            "Debe ser una fecha válida",
            function (fechaHasta) {
                if (!fechaHasta) return true;
                return fechaHasta instanceof Date && !isNaN(fechaHasta);
            }
        )
        .test(
            "fechaHasta-after-fechaDesde",
            "La fecha hasta debe ser posterior o igual a la fecha desde",
            function (fechaHasta) {
                const { fechaDesde } = this.parent;
                if (!fechaHasta || !fechaDesde || !(fechaHasta instanceof Date) || !(fechaDesde instanceof Date) || isNaN(fechaHasta) || isNaN(fechaDesde)) return true;
                return fechaHasta >= fechaDesde;
            }
        ),
});

const EstablecimientosToolbar = () => {

    const initialValues = {
        fechaDesde: null,
        fechaHasta: null,
    };

    return (
        <Formik
            key="establecimientos-toolbar-formik" // Key estable para preservar el estado del formulario
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnChange={true}
            validateOnBlur={true}
            validateOnMount={true} // Validar siempre al montar para detectar errores inmediatamente
            initialTouched={{
                fechaDesde: true,
                fechaHasta: true
            }} // Marcar campos como touched para mostrar errores desde el inicio
            onSubmit={() => { }}
        >
            {({ values, isValid, validateForm }) => (
                <Form>
                    <StyledEstablecimientos.ToolbarContainer>
                        <StyledEstablecimientos.DatePickersContainer>
                            <StyledEstablecimientos.DatePicker>
                                <FormikDatePicker
                                    name="fechaDesde"
                                    label="Fecha desde"
                                    ampm="false"
                                    format="dd/MM/yyyy"
                                    size="small"
                                    callback={() => setTimeout(() => validateForm(), 0)}
                                />
                            </StyledEstablecimientos.DatePicker>
                            <StyledEstablecimientos.DatePicker>
                                <FormikDatePicker
                                    name="fechaHasta"
                                    label="Fecha hasta"
                                    ampm="false"
                                    format="dd/MM/yyyy"
                                    size="small"
                                    callback={() => setTimeout(() => validateForm(), 0)}
                                />
                            </StyledEstablecimientos.DatePicker>
                        </StyledEstablecimientos.DatePickersContainer>
                        <ExportSiniestralidadButton
                            fechaDesde={values.fechaDesde ? moment(values.fechaDesde).toISOString() : null}
                            fechaHasta={values.fechaHasta ? moment(values.fechaHasta).toISOString() : null}
                            disabled={!isValid}
                        />
                    </StyledEstablecimientos.ToolbarContainer>
                </Form>
            )}
        </Formik>
    );
};

export default EstablecimientosToolbar;